




































































import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import { mask } from "vue-the-mask";
import { ValidationRules } from "_P/validate";
import { InsuranceCard } from "@/services/index.defs";
import { GaHelper } from "@/core/helpers/ga";
import { EventName, sendPostMessageEvent } from '@/utils/analyticMessages';

enum LSCarState {
    Model,
    Year
}
@Component({ directives: { mask } })
export default class LeftSideCar extends Vue {
    LSCarState = LSCarState;
    state = LSCarState.Model;
    Rules = ValidationRules;

    created() {
        // if (this.state == LSCarState.Model)
        //     this.$store.state.showRecentCalc = true;
    }
    @Watch("state")
    osStateChanged() {
        this.$store.state.showRecentCalc = this.state == LSCarState.Model;
    }
    @Watch("card.car.modelId")
    clearCarProps(newVal, oldVal) {
        if (oldVal) {
            this.card.car.modificationId = null;
            this.card.car.power = null;
            this.card.car.yearIssue = null;
        }
    }
    @Watch("card.car.markId") clearModelId(newVal, oldVal) {
        if (oldVal != null) {
            this.card.car.modelId = null;
            this.clearCarProps(null, this.card.car.modelId);
        }
    }

    markSelected(id) {
        this.$store.dispatch("dicti/getMapModels", this.card.car.markId);
        let mark = this.$store.state.dicti.mapMarks.find(x => x.id == id);
    }

    modelSelected() {
        this.$store.dispatch("dicti/getModifications", this.card.car.modelId);
        let markName = this.$store.state.dicti.mapModels.find(
            x => x.id == this.card.car.modelId
        ).title;
    }
    sendYearStats() {
    }

    get yearsItems() {
        let array = [];
        let currentYear = new Date().getFullYear();
        for (let i = 0; i < 70; i++) {
            array.push(currentYear);
            currentYear--;
        }
        return array;
    }

    @Ref("form") form: { validate: Function };
    next() {
        let isValid = this.form.validate();
        if (!isValid) return;

        if (this.state == LSCarState.Model) {
            GaHelper.send("manual/carYear");
            this.state = LSCarState.Year;
        } else {
            sendPostMessageEvent(EventName.CarInfo);
            this.$root.scrollUp();
            this.$emit("next");
        }
    }

    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }
    mounted() {
        GaHelper.send("begin/manual");
    }
}
